<template>
  <div class="member-container" :class="`${createRenderType}-member-container`">
    <div class="title" :class="createRenderType == 'pc' ? 'flex-center' : ''">
      {{ isRemember ? "你好，音疯会员" : "音疯会员" }}
    </div>
    <div :class="createRenderType == 'pc' ? 'flex-center' : ''">
      <div class="text">{{ $t("credit.remaining") }}: {{ currentCredits }}</div>
      <div class="show-tip" v-if="createRenderType == 'mobile'">
        每日赠送6积分（可生成6首歌），仅当日有效，不可累计使用
      </div>
      <div class="pointer view" @click="handleView">
        {{ $t("credit.viewDate") }}
      </div>
    </div>
    <div
      class="member flex1"
      :class="createRenderType == 'pc' ? 'flex' : 'flex-column'"
    >
      <div
        class="member-item"
        v-for="(item, index) in memberList"
        :key="item.product_id"
      >
        <div class="mask" v-if="item.extra_credit && countdown">
          <img src="@/assets/img/credit/mask.png" alt="" />
        </div>
        <div class="cutdown" v-if="item.extra_credit && countdown">
          <div class="duration flex-space-between">
            <img src="@/assets/img/credit/cut.png" alt="" />
            <div class="ctime">{{ formatTime(countdown) }}</div>
          </div>
          <div class="extra-credit">
            限时购买 <br />
            立赠 {{ item.extra_credit }} 积分
          </div>
        </div>
        <div class="name flex-row-center">
          <img
            class="name-img"
            v-if="showList[index].img"
            :src="showList[index].img"
            alt=""
          />
          {{ showList[index].name }}
        </div>
        <div class="price">
          <span class="symbol">¥</span>
          <span class="num"
            >{{ item.price || 0 }}
            <div class="flag" v-if="showList[index].discount">
              {{ showList[index].discount }}
            </div>
          </span>
          <span class="time">/{{ showList[index].duration }}</span>
        </div>
        <div class="btn flex">
          <div class="effect flex-center" v-if="item.in_effect == 1">
            生效中
          </div>
          <div
            v-else
            class="checkout flex-center pointer"
            :class="item.extra_credit && countdown ? 'cutdown-btn' : ''"
            @click="handleCheckout(item)"
          >
            购买
          </div>
        </div>
        <div class="tip">
          <p class="flex-row-center">
            {{ showList[index].time }}可获得{{ item.base_credit }}积分（生成
            {{ item.base_credit }}首歌）
          </p>
          <p class="flex-row-center">{{ showList[index].info }}</p>
          <p class="flex-row-center" v-if="showList[index].tip">
            {{ showList[index].tip }}
          </p>
          <p class="flex-row-center">
            {{ showList[index].add }}
          </p>
        </div>
      </div>
    </div>
    <div class="tip" v-if="createRenderType == 'pc'">
      每日赠送6积分（可生成6首歌），仅当日有效，不可累计使用
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps, onMounted } from "vue";
import { storeToRefs } from "pinia";
import Button from "../../store/component/button.vue";
import { getProducts, checkFirstPurchase } from "@/api/api/apiCredit.js";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import bacicImg from "@/assets/img/credit/basic.png";
import proImg from "@/assets/img/credit/pro.png";
import premierImg from "@/assets/img/credit/premier.png";

const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const props = defineProps({
  currentCredits: {
    type: Number,
    default: 0,
  },
});
const timer = ref(null);
const countdown = ref("");
const memberList = ref([]);
const isRemember = ref(false);
const showList = ref([
  {
    name: "基础月度会员",
    time: "",
    duration: "月",
    info: "积分有效期为30天",
    add: "下载无水印MP3",
  },
  {
    img: bacicImg,
    name: "高级月度会员",
    time: "",
    duration: "月",
    info: "积分有效期为30天",
    add: "下载无水印MP3",
  },
  {
    img: proImg,
    name: "超值季度会员",
    time: "总计",
    duration: "季",
    info: "每月发放200积分，连续发放3个月",
    tip: "每次发放的200积分有效期30天",
    discount: "九折优惠",
    add: "下载无水印MP3",
  },
  {
    img: premierImg,
    name: "尊享年度会员",
    time: "总计",
    duration: "年",
    info: "每月发放200积分，连续发放12个月",
    tip: "每次发放的200积分有效期为30天",
    discount: "八折优惠",
    add: "下载无水印MP3",
  },
]);
const emits = defineEmits(["handleCreditCheckout", "handleView"]);

watch(
  () => userDataStore.isLogin,
  (val) => {
    if (val) {
      getList();
      countdown.value = "";
      checkTime();
    } else {
      clearInterval(timer.value);
    }
  }
);

watch(
  () => countdown.value,
  (val) => {
    if (val === 0) {
      clearInterval(timer.value); // 倒计时结束，销毁定时器
    }
  }
);

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60); // 分钟数
  const remainingSeconds = seconds % 60; // 剩余的秒数

  let formattedMinutes = minutes;
  if (minutes === 0) {
    formattedMinutes = "00";
  }

  const formattedTime = `${formattedMinutes}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
  return formattedTime;
};

const handleCheckout = (item) => {
  emits("handleCreditCheckout", item);
};

const handleView = () => {
  emits("handleView");
};

const startCountdown = () => {
  timer.value = setInterval(() => {
    countdown.value--; // 每秒倒计时减一
  }, 1000);
};

const checkTime = () => {
  checkFirstPurchase({}).then((res) => {
    if (res.code == 200) {
      const { is_first, time_remaining } = res.data;
      if (is_first == 2 && time_remaining) {
        countdown.value = time_remaining;
        startCountdown();
      }
    }
  });
};

const getList = () => {
  getProducts("wechat_native", {}).then((res) => {
    if (res.code == 200) {
      const { list } = res.data;
      memberList.value = list;
      list.forEach((item) => {
        if (item.in_effect == 1) {
          isRemember.value = true;
        }
      });
    }
  });
};

onMounted(() => {
  getList();
  checkTime();
});
</script>

<style lang="scss" scoped>
.member-container {
  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 40px;
  }
  .text {
    margin-top: 4px;
    font-size: 16px;
    font-weight: 500;
  }
  .view {
    margin-top: 4px;
    font-size: 12px;
    margin-left: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    &:hover {
      color: #94adff;
      border-bottom: 1px solid #94adff;
    }
  }
  .member {
    font-family: HarmonyOS Sans SC;
    margin-top: 24px;
    justify-content: space-around;
    .member-item {
      position: relative;
      &:last-child {
        margin-right: 0 !important;
      }
      margin-right: 20px;
      width: 284px;
      height: 378px;
      border-radius: 13px;
      background: rgba(255, 255, 255, 0.25);
      backdrop-filter: blur(20px);
      padding: 28px 20px 32px;
      .mask {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        animation: fadeInOut 2s infinite;
        pointer-events: none;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        font-size: 16px;
        font-weight: 700;
        line-height: 28px;
        color: #fff;
        .name-img {
          margin-right: 4px;
          width: 22px;
          height: 22px;
        }
      }
      .price {
        position: relative;
        margin-top: 24px;
        display: flex;
        align-items: flex-end;
        .flag {
          position: absolute;
          top: -6px;
          left: 96px;
          background: linear-gradient(110deg, #a2ff7d 0%, #ffe95e 100%);
          width: 52px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          color: #070d13;
          border-radius: 10px 10px 10px 2px;
          font-size: 10px;
          font-weight: 500;
        }
        .symbol {
          margin-right: 8px;
          font-size: 20px;
          transform: translateY(-6px);
        }
        .num {
          font-size: 40px;
        }
        .time {
          font-size: 20px;
          font-weight: 900;
          transform: translateY(-6px);
        }
      }
      .btn {
        margin: 43px auto 0;
        width: 100%;
        height: 40px;
        font-size: 14px;
        font-weight: 500;
        .effect {
          width: 100%;
          height: 100%;
          border-radius: 62px;
          color: rgba(255, 255, 255, 0.8);
          background: rgba(255, 255, 255, 0.2);
        }
        .checkout {
          width: 100%;
          height: 100%;
          border-radius: 62px;
          color: #000;
          background: linear-gradient(100deg, #4fdeff 0%, #e675ff 99%);
        }
        .cutdown-btn {
          background: linear-gradient(99deg, #4FDEFF -2%, #D9F8FF 54%, #E675FF 105%);
        }
      }
      .tip {
        margin-top: 24px;
        p {
          margin-bottom: 4px;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          color: rgab(255, 255, 255, 0.6);
          &::before {
            content: "";
            width: 16px;
            height: 16px;
            margin-right: 4px;
            background: url("@/assets/img/credit/flag.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .cutdown {
        position: absolute;
        top: 66px;
        right: 9px;
        width: 106px;
        height: 94px;
        background: url("@/assets/img/credit/bg.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 12px;
        .duration {
          width: 100%;
          height: 24px;
          padding: 8px 12px;
          margin: 12px 0 8px;
          font-size: 12px;
          font-weight: 500;
          line-height: 14px;
          color: #fbff00;
          border-radius: 50px;
          background: #000;
          img {
            width: 12px;
            height: 12px;
            margin-right: 3px;
          }
          .ctime {
            font-size: 16px;
            font-weight: 500;
            line-height: 14px;
            color: #fbff00;
          }
        }
        .extra-credit {
          margin: 9px 0 0 11px;
          color: #000;
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }
      }
    }
  }
  .tip {
    margin-top: 70px;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: #fff;
    opacity: 0.6;
    justify-content: flex-end;
    text-align: center;
  }
}
.mobile-member-container {
  .view {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 110px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    margin: 14px 0 0;
  }
  .member {
    margin-top: 24px;
    .member-item {
      position: relative;
      width: 100%;
      padding: 24px 24px 28px;
      height: max-content;
      margin: 0 0 16px;
      .price {
        position: relative;
        margin-top: 24px;
        display: flex;
        align-items: flex-end;
        .symbol {
          margin-right: 8px;
          font-size: 20px;
          transform: translateY(-6px);
        }
        .num {
          font-size: 40px;
          position: relative;
          .flag {
            position: absolute;
            top: -11px;
            left: 100%;
            background: linear-gradient(110deg, #a2ff7d 0%, #ffe95e 100%);
            width: 52px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            color: #070d13;
            border-radius: 10px 10px 10px 2px;
            font-size: 10px;
            font-weight: 500;
          }
        }
        .time {
          font-size: 20px;
          font-weight: 900;
          transform: translateY(-6px);
        }
      }
      .btn {
        margin: 40px 0 0;
        // width: calc(100% - 42px);
        width: 100%;
        height: 46px;
        .effect {
          width: 100%;
          height: 100%;
          border-radius: 62px;
          color: rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(255, 255, 255, 0.8);
        }
      }
    }
  }
  .show-tip {
    margin-top: 8px;
    padding-bottom: 0;
    color: #9daaff;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
  }
}
</style>